import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './ImageSlider.css';

import slide1 from "../assets/grid/1.png";
import grid1 from "../assets/grid/21122x1519.png";
import grid2 from "../assets/grid/31122x1519.png";
import grid3 from "../assets/grid/41122x1519.png";
import grid4 from "../assets/grid/51122x1519.png";
import grid5 from "../assets/grid/61122x1519.png";
import grid6 from "../assets/grid/71122x1519.png";
import grid7 from "../assets/grid/81122x1519.png";
import grid8 from "../assets/grid/91122x1519.png";
import grid9 from "../assets/grid/101122x1519.png";
import grid10 from "../assets/grid/111122x1519.png";
import grid11 from "../assets/grid/121122x1519.png";
import grid12 from "../assets/grid/131122x1519.png";

const images = [slide1, grid1, grid2, grid3, grid4, grid5, grid6, grid7, grid8, grid9, grid10, grid11, grid12];

const ImageSlider = () => {
  const [autoplay, setAutoplay] = useState(true);
  const [modalIndex, setModalIndex] = useState(null);

  const handleImageClick = (index) => {
    setAutoplay(false);
    setModalIndex(index);
  };

  const closeModal = () => {
    setModalIndex(null);
    setAutoplay(true);
  };

  return (
    <div className="w-full sm:max-w-[98%] mx-auto p-4 relative">
      <Helmet>
        <title>Advanced Slot Management Software for Land-Based Casinos</title>
        <meta
          name="description"
          content="Enhance your casino operations with our advanced slot management software, offering real-time analytics, game monitoring, and seamless integration."
        />
      </Helmet>

      {/* Main Slider */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={autoplay ? { delay: 3000, disableOnInteraction: false } : false}
        loop={true}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="rounded-lg"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <img
              src={img}
              alt={`Slide ${i}`}
              className="w-full rounded-lg shadow-lg object-cover cursor-pointer"
              onClick={() => handleImageClick(i)}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Zoomed Modal Slider */}
      {modalIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-[80%] max-h-[90%]"
            onClick={(e) => e.stopPropagation()}
          >
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              initialSlide={modalIndex}
              className=" w-full h-full"
            >
              {images.map((img, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={img}
                    alt={`Zoomed Slide ${i}`}
                    className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
                    onClick={(e) => e.stopPropagation()}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Close Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}
              className="absolute top-2 right-2 z-[9999] text-white text-3xl hidden lg:block bg-black bg-opacity-50 rounded-full p-1 hover:bg-opacity-75 transition"
            >
X            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
